import {type ReactNode} from "react";
import Moment from "moment";
import Bell from "~/assets/icons/bell.svg"
import Icon from "~/components/ui/Icon";

interface Props {
  children: ReactNode;
  header: string;
  date: Date;
  visible?: boolean;
}

export default function NewsCard({children, header, date, visible}: Props) {
  return (
    <div className="bg-white p-[40px] shadow-[0_4px_16px_0_rgba(0,0,0,0.08)] w-full rounded-[32px] mt-12">
      <Icon visible={visible}>
        <Bell />
      </Icon>
      <div className="flex flex-col">
        <h3 className={"h3 text-primary !font-[800]" + (visible === false ? " opacity-40" : "")}>{header}</h3>
        <div className={"mb-6 text-[16px] font-[400] text-primary" + (visible === false ? " opacity-40" : "")}>{Moment(date).format('DD. MM. YYYY • HH:mm')}</div>
        <div className="paragraph">
          {children}
        </div>
      </div>
    </div>
  )
}
